import React, { useState, useEffect, useCallback } from 'react';
import { STORAGE_KEYS } from '../constants/storageKeys';
import { BASE_URL } from '../constants/config';
import { showToast, showAlert } from '../components/Toast';
import AppShell from '../components/AppShell';

const formatDate = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  const dd = String(d.getDate()).padStart(2, '0');
  const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  return `${dd} ${months[d.getMonth()]}, ${d.getFullYear()}`;
};

const formatINR = (value) => {
  if (value === null || value === undefined) return '₹ 0.00';
  return '₹ ' + value.toLocaleString('en-IN', { maximumFractionDigits: 2, minimumFractionDigits: 2 });
};

const EmpCreditListScreen = ({ params, onBack }) => {
  const empId = params?.empId;
  const [credits, setCredits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const empCode = localStorage.getItem(STORAGE_KEYS.EMP_CODE);
  const getToken = () => localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);

  const fetchCredits = useCallback(async (isRefresh = false) => {
    try {
      if (isRefresh) setRefreshing(true); else setLoading(true);
      const response = await fetch(`${BASE_URL}api/Expense/EMPACCredit/ListByEmp/${empId}`, {
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      if (response.ok) setCredits(await response.json());
      else showToast(`Failed to load credits (${response.status})`, 'error');
    } catch (_) {
      showToast('Could not load credits.', 'error');
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  }, [empId]);

  useEffect(() => { fetchCredits(); }, [fetchCredits]);

  const handleDelete = (id) => {
    showAlert('Delete Credit', 'Are you sure you want to delete this credit entry?', [
      { text: 'Cancel', style: 'cancel' },
      {
        text: 'Delete', style: 'destructive', onPress: async () => {
          try {
            setLoading(true);
            const response = await fetch(`${BASE_URL}api/Expense/EMPACCredit/Delete/${id}`, {
              method: 'DELETE',
              headers: { Authorization: `Bearer ${getToken()}` },
            });
            if (response.ok) { showToast('Credit deleted.', 'success'); fetchCredits(); }
            else { showToast(`Failed to delete (${response.status})`, 'error'); setLoading(false); }
          } catch (_) { showToast('Could not delete credit.', 'error'); setLoading(false); }
        }
      },
    ]);
  };

  return (
    <AppShell
      title="Credit History"
      onBack={onBack}
      rightAction={{ icon: '↻', onClick: () => fetchCredits(true), label: 'Refresh' }}
    >
      {loading ? (
        <div className="loading-screen"><div className="spinner spinner--gold" /><p>Loading credits...</p></div>
      ) : credits.length === 0 ? (
        <div style={{ textAlign: 'center', marginTop: 80, color: '#aaa' }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>💸</div>
          <div>No credits found for this employee.</div>
        </div>
      ) : (
        <div style={{ padding: 16, paddingBottom: 40 }}>
          {refreshing && <div style={{ textAlign: 'center', padding: 8, color: '#999', fontSize: 13 }}>Refreshing...</div>}
          {credits.map(item => (
            <div key={item.ID} style={{
              background: '#fff', borderRadius: 12, marginBottom: 12, padding: 12,
              boxShadow: '0 1px 4px rgba(0,0,0,0.08)', display: 'flex', alignItems: 'center',
            }}>
              <div style={{
                background: '#f0f4ff', borderRadius: 8, width: 48, height: 48,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 22, marginRight: 16, flexShrink: 0,
              }}>💰</div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 15, color: '#333', fontWeight: 500 }}>{formatDate(item.Date)}</div>
                <div style={{ fontSize: 16, fontWeight: 700, color: '#1a7a3c' }}>{formatINR(item.Amount)}</div>
              </div>
              {empCode === 'A' && (
                <button
                  onClick={() => handleDelete(item.ID)}
                  style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#c62828', padding: 8 }}
                >🗑️</button>
              )}
            </div>
          ))}
        </div>
      )}
    </AppShell>
  );
};

export default EmpCreditListScreen;
